import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import "./assets/styles/index.scss";
import ElementPlus from "element-plus";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import "element-plus/dist/index.css";
import plugins from "./plugins";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
// 分页组件
import Pagination from "@/components/Pagination";
const app = createApp(App);
app.component("Pagination", Pagination);
app.use(ElementPlus, {
  locale: zhCn,
});
app.use(router);
app.use(plugins);
app.mount("#app");
